import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SignInPage from "./pages/auth/SignIn";
import SignUpPage from "./pages/auth/SignUp";
import VerifyEmailPage from "./pages/auth/VerifyEmail";
import ForgotPasswordPage from "./pages/auth/ForgotPassword";
import ResetPasswordPage from "./pages/auth/ResetPassword";
import Dashboard from "./pages/Dashboard";
import ProfileDashboard from "./pages/dashboard/ProfileDashboard";
import RegistrationDashboard from "./pages/dashboard/RegistrationDashboard";
import TeamDashboard from "./pages/dashboard/TeamDashboard";
import TeamDetailsPage from "./pages/dashboard/TeamDetailsPage";
import ChangePassword from "./pages/dashboard/ChangePassword";
import { PaymentPage } from "./pages/payment/PaymentPage";
import PaymentListPage from "./pages/payment/PaymentListPage";
import FAQ from "./pages/dashboard/FAQ";
import CompetitionsPage from "./pages/dashboard/competitions/CompetitionsPage";
import CompetitionDetailPage from "./pages/dashboard/competitions/CompetitionDetailPage";
import DashboardLayout from "./components/layouts/DashboardLayout";
import "./App.css";

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const token = localStorage.getItem("token");
  return token ? <>{children}</> : <Navigate to="/auth/signin" />;
};

// Public Route Component (redirect if already authenticated)
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = localStorage.getItem("token");
  return !token ? <>{children}</> : <Navigate to="/dashboard/profile" />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route
            path="/auth/signin"
            element={
              <PublicRoute>
                <SignInPage />
              </PublicRoute>
            }
          />
          <Route
            path="/auth/signup"
            element={
              <PublicRoute>
                <SignUpPage />
              </PublicRoute>
            }
          />
          <Route
            path="/auth/verify-email"
            element={
              <PublicRoute>
                <VerifyEmailPage />
              </PublicRoute>
            }
          />
          <Route
            path="/auth/forgot-password"
            element={
              <PublicRoute>
                <ForgotPasswordPage />
              </PublicRoute>
            }
          />
          <Route
            path="/auth/reset-password"
            element={
              <PublicRoute>
                <ResetPasswordPage />
              </PublicRoute>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/profile"
            element={
              <ProtectedRoute>
                <ProfileDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/registration"
            element={
              <ProtectedRoute>
                <RegistrationDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/team"
            element={
              <ProtectedRoute>
                <TeamDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/team/:teamId"
            element={
              <ProtectedRoute>
                <TeamDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/payment"
            element={
              <ProtectedRoute>
                <PaymentListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/payment/form"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <PaymentPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/competitions"
            element={
              <ProtectedRoute>
                <CompetitionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/competitions/:teamId"
            element={
              <ProtectedRoute>
                <CompetitionDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/faq"
            element={
              <ProtectedRoute>
                <FAQ />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/change-password"
            element={
              <ProtectedRoute>
                <DashboardLayout>
                  <ChangePassword />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/auth/signin" />} />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/auth/signin" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
